<template>
	<div :class="{ 'top-nav-container': true, 'is-hidden': hideTopbar, 'my-card-page': isMyCardPage }">
		<nav id="top-nav" class="top-bar">
			<div id="top-nav-background">
				<img src="@/assets/svgs/bg-top-nav-summer.svg" v-if="selectedSeason === 'sommer'" />
				<img src="@/assets/svgs/bg-top-nav-winter.svg" v-if="selectedSeason === 'winter'" />
			</div>

			<div class="top-bar-left">
				<span class="season-indicator top-bar-indicator" v-if="!hideIndicator">
					<font-awesome-icon :icon="seasonIcon" class="season-indicator-icon" /> {{ $t(`seasons.${this.$store.state.season}`) }}
				</span>

				<back-button v-if="hideIndicator" />
			</div>
			<div class="top-bar-center">
				<router-link :to="{ name: 'home' }">
					<img src="@/assets/imgs/kc-logo.png" alt="Kärnten Card Logo">
				</router-link>
			</div>
			<div class="top-bar-right">
				<span class="language-indicator top-bar-indicator" v-if="!hideIndicator">
					{{ this.$i18n.locale.toLocaleUpperCase() }}
				</span>
			</div>
		</nav>

		<section id="page-actions" :class="`route-${this.$route.name}`">
			<slot></slot>
		</section>
	</div>
</template>
<script>
	import BackButton from '@/components/BackButton.vue'

	export default {
		name: 'TopNavigation',
		components: {
			BackButton
		},
		computed: {
			selectedSeason () {
				if (this.isMyCardPage) {
					return 'sommer'
				}

				return this.$store.state.season
			},
			seasonIcon () {
				if (this.selectedSeason === 'sommer') {
					return ['fal', 'sun']
				} else {
					return ['fal', 'snowflake']
				}
			},
			hideIndicator () {
				switch(this.$route.name) {
					case 'news':
						return true
					case 'single-news':
						return true
					case 'bookmarks':
						return true
					case 'my-card':
						return true
					case 'my-card-register':
						return true
				}

				return false
			},
			hideTopbar () {
				switch(this.$route.name) {
					case 'single-news':
						return true
					case 'map':
						return true
					case 'single-destination':
						return true
					case 'single-salespoint':
						return true
				}
				return false
			},
			isMyCardPage () {
				return this.$route.name === 'my-card' || this.$route.name === 'my-card-register'
			}
		}
	}
</script>
<style lang="scss" scoped>
	.top-nav-container{
		position: relative;
		padding-bottom: 1rem;
		border-bottom: 1px solid $light-gray;
		box-shadow: 0px 1px 2px rgba($black, .15);
		z-index: 1;

		&.my-card-page{
			background-color: get-color(secondary);
			border-bottom: none;
			box-shadow: none;

			#top-nav{
				background-color: get-color(secondary);
			}
		}
	}
	#top-nav{
		position: relative;

		#top-nav-background{
			position: absolute;
			left: 0;
			right: 0;
			top: -.5rem;
			z-index: 0;

			img {
				position: absolute;
				bottom: -6.5rem;
				left: 0;
				right: 0;
				width: 100%;

				@media screen and (min-width: 499px) and (max-width: 639px) {
					bottom: -7.5rem;
				}

				@include breakpoint(medium only) {
					bottom: -8.5rem ;
				}

				@include breakpoint(large only) {
					bottom: -8.5rem;
				}

				@include breakpoint(xlarge only) {
					bottom: -11.5rem;
				}

				@include breakpoint(xxlarge up) {
					bottom: -13rem;
				}
			}


		}

		.top-bar-indicator {
			display: inline-block;
			color: $light-gray;
			line-height: 2;

			&.language-indicator{
				display: inline-flex;
				justify-content: center;
				align-items: center;
				width: 2rem;
				height: 2rem;
				border-radius: 50%;
				border: 1px solid $light-gray;
			}

			@include breakpoint(medium only) {
				text-shadow: 0 0 2px #333333;


				.season-indicator-icon {
					filter:drop-shadow(0 0 2px #333333)
				}
			}

			@include breakpoint(large up) {
				color: $dark-gray;


			}
		}

		&.top-bar{
			@include xy-grid();
			align-items: flex-start;
			padding: 0 rem-calc(15);
			padding-top: rem-calc(15);
			padding-bottom: 1rem;

			.top-bar-left,
			.top-bar-right,
			.top-bar-center {
				@include xy-cell(3, false, 0);
				display: flex;
				align-items: flex-start;
				position: relative;
				z-index: 5;
				margin-bottom: 1rem;

				img{
					width: rem-calc(125);
					height: auto;
					transform: rotate(-6deg) translate(0, 15%);
				}
			}

			.top-bar-left{
				justify-content: flex-start;
				text-align: left;
				margin-left: 0;
				margin-right: auto;
			}

			.top-bar-right{
				justify-content: flex-end;
				text-align: right;
				margin-right: 0;
				margin-left: auto;
			}

			.top-bar-center{
				@include xy-cell(6);
				justify-content: center;
				align-items: center;
				text-align: center;
			}
		}
	}
</style>